// https://medium.com/@michael.kutateladze/react-router-with-a-single-config-file-61777f306b4f

import { ComponentType } from 'react'

import AddDatasetPage from '../routes/Datasets/AddDatasetPage'
import DatasetsRoot from '../routes/Datasets/DatasetsRoot'
import ImagesRoot from '../routes/Images/ImagesRoot'
import NotFound404Root from '../routes/NotFound404/NotFound404Root'
import ProductsRoot from '../routes/Products/ProductsRoot'
import ProjectsRoot from '../routes/Projects/ProjectsRoot'
import SearchRoot from '../routes/Search/SearchRoot'
import SignInRoot from '../routes/SignIn/SignInRoot'
import TrainingRoot from '../routes/Training/TrainingRoot'
import TrainingNewRoot from '../routes/TrainingNew/TrainingNewRoot'
import TrainingsRoot from '../routes/Trainings/TrainingsRoot'
import AnomalyScorePlot from '../routes/TrainingTest/AnomalyScorePlot'
import TrainingTestRoot from '../routes/TrainingTest/TrainingTestRoot'
import TrainingTestNewRoot from '../routes/TrainingTestNew/TrainingTestNewRoot'
import LoggedInTemplate from '../templates/LoggedInTemplate'
import SignInTemplate from '../templates/SignInTemplate'

export interface Route {
  path: string
  exact: boolean
  isPrivate: boolean
  redirect?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: ComponentType<any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  template?: ComponentType<any>
}

export const routes: Route[] = [
  {
    path: '/',
    exact: true,
    isPrivate: true,
    redirect: '/projects',
  },
  {
    path: '/sign-in',
    exact: true,
    isPrivate: false,
    component: SignInRoot,
    template: SignInTemplate,
  },
  {
    path: '/projects',
    exact: true,
    isPrivate: true,
    component: ProjectsRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/search',
    exact: true,
    isPrivate: true,
    component: SearchRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/projects/:projectId/products',
    exact: true,
    isPrivate: true,
    component: ProductsRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/projects/:projectId/products/:productId/trainings',
    exact: true,
    isPrivate: true,
    component: TrainingsRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/projects/:projectId/products/:productId/trainings/:trainingId',
    exact: true,
    isPrivate: true,
    component: TrainingRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/projects/:projectId/products/:productId/images',
    exact: true,
    isPrivate: true,
    component: ImagesRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/projects/:projectId/products/:productId/datasets',
    exact: true,
    isPrivate: true,
    component: DatasetsRoot,
    template: LoggedInTemplate,
  },
  {
    path: '/projects/:projectId/products/:productId/dataset',
    exact: true,
    isPrivate: true,
    component: AddDatasetPage,
    template: LoggedInTemplate,
  },
  {
    path: '/projects/:projectId/products/:productId/dataset/:datasetId',
    exact: true,
    isPrivate: true,
    component: AddDatasetPage,
    template: LoggedInTemplate,
  },
  {
    path: '/projects/:projectId/products/:productId/new-training',
    exact: true,
    isPrivate: true,
    component: TrainingNewRoot,
    template: LoggedInTemplate,
  },
  {
    path:
      '/projects/:projectId/products/:productId/trainings/:trainingId/training-tests/:trainingTestId',
    exact: true,
    isPrivate: true,
    component: TrainingTestRoot,
    template: LoggedInTemplate,
  },
  {
    path:
      '/projects/:projectId/products/:productId/trainings/:trainingId/new-test',
    exact: true,
    isPrivate: true,
    component: TrainingTestNewRoot,
    template: LoggedInTemplate,
  },
  {
    path:
      '/projects/:projectId/products/:productId/trainings/:trainingId/training-tests/:trainingTestId/anomaly-score-plot',
    exact: true,
    isPrivate: true,
    component: AnomalyScorePlot,
    template: LoggedInTemplate,
  },
  {
    path: '*',
    exact: false,
    isPrivate: true,
    component: NotFound404Root,
    template: LoggedInTemplate,
  },
]
